import i18n from "../../i18n";

export const isRequired = {
  required: true,
  message: i18n.t("error_is_required"),
};

export const isPhoneNumber = {
  pattern: /^\d{10}$/,
  message: i18n.t("error_is_phone_number"),
};

export const isEmail = {
  pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  message: i18n.t("error_is_email"),
};

export const validatePasswordLength = {
  min: 6,
  message: i18n.t("error_password_length"),
};

export const validatePassWordConfirm = ({ getFieldValue }: any) => ({
  validator(rule: any, value: any) {
    if (!value || value.length === 0) {
      return Promise.reject(i18n.t("error_is_required"));
    } else {
      if (value.length >= 6) {
        if (
          !value ||
          getFieldValue("password") === value ||
          getFieldValue("newPassword") === value
        ) {
          return Promise.resolve();
        }
        return Promise.reject(i18n.t("error_password_confirm"));
      } else {
        return Promise.reject(i18n.t("error_password_length"));
      }
    }
  },
});
